import { Routes, Route, useLocation } from 'react-router-dom';
import {
  Header,
  Hero,
  TrustedBySection,
  ServicesSection,
  AboutSection,
  ContactSection,
  Footer,
  FloatingWhatsApp,
} from './components';
import LeyPage from './pages/LeyPage';
import FalconPage from './pages/FalconPage';
import { getCalendarHomeVariant } from './utils/calendarHomeVariant';
import './App.css';

function HomePage() {
  return (
    <>
      <Hero />
      <TrustedBySection />
      <ServicesSection />
      <AboutSection />
      <ContactSection />
    </>
  );
}

/** "/" shows Home, Ley, or Falcon depending on day of month (see calendarHomeVariant). */
function CalendarHomeRoute() {
  const variant = getCalendarHomeVariant();
  if (variant === 'ley') return <LeyPage />;
  if (variant === 'falcon') return <FalconPage />;
  return <HomePage />;
}

function App() {
  const location = useLocation();
  const isFalconRoute = location.pathname === '/falcon';

  return (
    <div className={`app ${isFalconRoute ? 'app--falcon' : ''}`}>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<CalendarHomeRoute />} />
          <Route path="/abogados" element={<HomePage />} />
          <Route path="/ley" element={<LeyPage />} />
          <Route path="/falcon" element={<FalconPage />} />
        </Routes>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
